import Image from 'next/image';
import React, { useState } from 'react';
import { useProductComments } from '@/app/_hooks/useComment';
import More from '@/app/_components/ui/icons/More.svg';

export default function CommentsWithImage({ id, openCommentsWithImage }) {
  const { productCommentsInfo } = useProductComments(id, 'image', 1);
  const comments = productCommentsInfo.data;

  if (comments && comments.length > 0)
    return (
      <div className="border-t border-dashed border-light-gray-300 pt-8">
        <div className="text-sm font-bold mb-8 ">
          بررسی تصاویر ارسالی کاربران
        </div>
        <div className="flex">
          {comments.slice(0, 3).map((comment) => (
            <div
              key={comment.id}
              className="border border-light-gray-300 rounded-md ml-2"
              onClick={() => openCommentsWithImage(comment.id)}
            >
              <Image src={comment.images[0].full_path} width={70} height={70} />
            </div>
          ))}
          {comments.length > 3 && (
            <div
              key={comments[3].id}
              className="border border-light-gray-300 rounded-md ml-2 relative"
              onClick={() => openCommentsWithImage(comments[3].id)}
            >
              <Image
                src={comments[3].images[0].full_path}
                placeholder="blur"
                blurDataURL="/images/no-image.jpg"
                className="blur"
                width={70}
                height={70}
              />
              <div className="absolute top-6 left-6">
                <More />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  else return <></>;
}
